module.exports = __webpack_public_path__ + "static/media/windIcon.4d75d165.svg";